import { getDefaultClient } from '../../../client/defaultClient';
import { assertDefined } from '../../../utils/assertDefined';
import { isPendingRecoveryCodesAcknowledgment } from '../../mfa/isPendingRecoveryCodesAcknowledgment';
import { isUserMissingMfaAuth } from '../../mfa/isUserMissingMfaAuth';

/**
 * Checks if the user has completed all onboarding requirements.
 *
 * This function verifies whether a user has fulfilled all necessary requirements
 * including KYC fields (Know Your Customer information) and MFA setup
 * (Multi-Factor Authentication including recovery codes acknowledgment).
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns True if onboarding is complete (no pending requirements), false if there are pending requirements.
 */
export const isUserOnboardingComplete = (client = getDefaultClient()) => {
  const user = client.user;

  assertDefined(user, 'User not logged in');

  const hasMissingKycFields = Boolean(user.missingFields?.length);
  const hasPendingMfaAuth = isUserMissingMfaAuth(client);
  const hasPendingRecoveryCodes = isPendingRecoveryCodesAcknowledgment(client);

  const userOnboardingComplete = !hasMissingKycFields && !hasPendingMfaAuth && !hasPendingRecoveryCodes;

  return userOnboardingComplete;
};
